import './GlobalFontSizeVariables.css';
export var fontSizeWrapper = '_eom86z0-3-15-1';